var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcTradeFrequencyColorfulDark = function SvgIcTradeFrequencyColorfulDark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 17.5,
    r: 17.5,
    fill: "#374643"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.09 10.774a1.094 1.094 0 0 1 1.544.096l3.217 3.646a1.094 1.094 0 0 1-.82 1.817H12.094a1.094 1.094 0 0 1 0-2.187h8.514l-1.614-1.829a1.094 1.094 0 0 1 .097-1.543ZM16.034 24.226c-.453.4-1.144.357-1.543-.096l-3.217-3.646a1.094 1.094 0 0 1 .82-1.817H23.03a1.094 1.094 0 0 1 0 2.187h-8.513l1.613 1.829c.4.453.356 1.144-.097 1.543Z",
    fill: "#52E6E6"
  })));
};
export default SvgIcTradeFrequencyColorfulDark;